import {pronounceSafeSeq} from "../../lib/sequences";
import copy from "copy-to-clipboard";
import routes from "../../routes";
import useBling from "../../lib/hooks/useBling";
import publicProjectRoutes from "../public-project/public-project-routes";
import {TooltipForChild, isMac, isWithMetaKey} from "@cdx/common";
import cdxEnv from "../../env";
import {DSButton, DSIconButton, DSIconGlobe} from "@cdx/ds";

const getPublicCardUrl = (card) =>
  card.deck?.project.isPublic &&
  publicProjectRoutes.publicProjectWithDeckAndCard.getUrl(card.deck.project, card.deck, card);

const CardIdButton = ({card}) => {
  const [blingRef, setMessage] = useBling();

  const publicCardUrl = getPublicCardUrl(card);
  const cardUrl = routes.handWithCard.getUrl(card);

  const handleCardIdToClipboard = (e) => {
    if (isWithMetaKey(e)) {
      copy(`$${pronounceSafeSeq.intToSeq(card.accountSeq)}`);
      setMessage("id copied!");
    } else {
      const path = process.env.REACT_APP_MODE === "open" ? publicCardUrl : cardUrl;
      copy(`${window.location.protocol}//${window.location.host}${path}`);
      setMessage("copied!");
    }
  };

  return (
    <TooltipForChild
      tooltip={`Card id. Click to copy link to clipboard. Use ${
        isMac() ? "cmd" : "ctrl"
      }+click to copy id.`}
      placement="right"
      delayed
      ref={blingRef}
    >
      <DSButton variant="tertiary" onClick={handleCardIdToClipboard} size="sm" negatePadding>
        ${pronounceSafeSeq.intToSeq(card.accountSeq)}
      </DSButton>
    </TooltipForChild>
  );
};

export const PublicCardButton = ({card}) => {
  const [blingRef, setMessage] = useBling();
  if (process.env.REACT_APP_MODE === "open") return null;
  const publicCardUrl = getPublicCardUrl(card);
  if (!publicCardUrl) return null;

  const handlePublicClipboard = () => {
    copy(`${cdxEnv.OPEN_APP_HOST}${publicCardUrl}`);
    setMessage("copied!");
  };

  return (
    <TooltipForChild
      tooltip="Click to copy public URL to clipboard."
      placement="top"
      delayed
      ref={blingRef}
    >
      <DSIconButton
        variant="tertiary"
        size="md"
        negatePadding
        icon={<DSIconGlobe />}
        onClick={handlePublicClipboard}
      />
    </TooltipForChild>
  );
};

export default CardIdButton;
